export const ACCESSORIAL_DOCUMENT = {
  name: 'Accessorial Document',
  value: 'accessorial_document',
  carrierCanView: true,
  carrierCanUpload: false,
  shipperCanView: false,
  shipperCanUpload: false,
  localizationSlug: 'ACCESSORIAL_DOCUMENT',
};

export const BARCODE = {
  name: 'Barcode',
  value: 'barcode',
  carrierCanView: false,
  carrierCanUpload: false,
  shipperCanView: false,
  shipperCanUpload: false,
  localizationSlug: 'BARCODE',
};

export const BARE_CHASSIS_INTERCHANGE = {
  name: 'Bare Chassis Interchange',
  value: 'bare_chassis_interchange',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'BARE_CHASSIS_INTERCHANGE',
};

export const BILL_OF_LADING = {
  name: 'Bill of Lading',
  value: 'bill_of_lading',
  carrierCanView: true,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'BILL_OF_LADING',
};

export const BOBTAIL_CARGOMATIC_APPROVAL = {
  name: 'Bobtail Cargomatic Approval',
  value: 'bobtail_cargomatic_approval',
  carrierCanView: true,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'BOBTAIL_CARGOMATIC_APPROVAL',
};

export const CARRIER_INVOICE = {
  name: 'Carrier Invoice',
  value: 'carrier_invoice',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: false,
  shipperCanUpload: false,
  localizationSlug: 'CARRIER_INVOICE',
};

export const CHASSIS_INTERCHANGE_IN = {
  name: 'Chassis Interchange In',
  value: 'chassis_interchange_in',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'CHASSIS_INTERCHANGE_IN',
};

export const CHASSIS_INTERCHANGE_OUT = {
  name: 'Chassis Interchange Out',
  value: 'chassis_interchange_out',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'CHASSIS_INTERCHANGE_OUT',
};

export const CHASSIS_INVOICE = {
  name: 'Chassis Invoice',
  value: 'chassis_invoice',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'CHASSIS_INVOICE',
};

export const CHASSIS_PHOTO = {
  name: 'Chassis Photo',
  value: 'chassis_photo',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'CHASSIS_PHOTO',
};

export const CLASSIC_POD = {
  name: 'Classic POD',
  value: 'classic_pod',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'CLASSIC_POD',
};

export const CREDIT_MEMO = {
  name: 'Credit Memo',
  value: 'credit_memo',
  carrierCanView: false,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: false,
  requiredPreference: true,
  localizationSlug: 'CREDIT_MEMO',
  count: 1,
};

export const CROSSDOCK_TALLY_SHEET = {
  name: 'Crossdock Talley Sheet',
  value: 'crossdock_tally_sheet',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'CROSSDOCK_TALLY_SHEET',
};

export const CTF_RECEIPT = {
  name: 'CTF Receipt',
  value: 'ctf_receipt',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'CTF_RECEIPT',
};

export const CUSTOM = {
  name: 'Custom',
  value: 'custom',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'CUSTOM',
};

export const CUSTOMER_APPROVAL = {
  name: 'Customer Approval',
  value: 'customer_approval',
  carrierCanView: false,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'CUSTOMER_APPROVAL',
};

export const CUSTOMER_BILL_OF_LADING = {
  name: 'Bill of Lading',
  value: 'customer_bill_of_lading',
  carrierCanView: true,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'CUSTOMER_BILL_OF_LADING',
};

export const CUSTOMER_BOBTAIL_APPROVAL = {
  name: 'Customer Bobtail Approval',
  value: 'customer_bobtail_approval',
  carrierCanView: false,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'CUSTOMER_BOBTAIL_APPROVAL',
};

export const CUSTOMER_CHASSIS_SPLIT_APPROVAL = {
  name: 'Customer Chassis Split Approval',
  value: 'customer_chassis_split_approval',
  carrierCanView: false,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'CUSTOMER_CHASSIS_SPLIT_APPROVAL',
};

export const CUSTOMER_DELIVERY_ORDER = {
  name: 'Delivery Order',
  value: 'customer_delivery_order',
  carrierCanView: false,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'CUSTOMER_DELIVERY_ORDER',
};

export const CUSTOMER_DEMURRAGE_APPROVAL = {
  name: 'Customer Demurrage Approval',
  value: 'customer_demurrage_approval',
  carrierCanView: false,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'CUSTOMER_DEMURRAGE_APPROVAL',
};

export const CUSTOMER_DRY_RUN_APPROVAL = {
  name: 'Customer Dry Run Approval',
  value: 'customer_dry_run_approval',
  carrierCanView: false,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'CUSTOMER_DRY_RUN_APPROVAL',
};

export const CUSTOMER_PER_DIEM_APPROVAL = {
  name: 'Customer Per Diem Approval',
  value: 'customer_per_diem_approval',
  carrierCanView: false,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'CUSTOMER_PER_DIEM_APPROVAL',
};

export const CUSTOMER_PREPULL_APPROVAL = {
  name: 'Customer Pre-Pull Approval',
  value: 'customer_prepull_approval',
  carrierCanView: false,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'CUSTOMER_PREPULL_APPROVAL',
};

export const CUSTOMER_STOP_OFF_APPROVAL = {
  name: 'Customer Stop-Off Approval',
  value: 'customer_stop_off_approval',
  carrierCanView: false,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'CUSTOMER_STOP_OFF_APPROVAL',
};

export const CUSTOMER_STORAGE_APPROVAL = {
  name: 'Customer Storage Approval',
  value: 'customer_storage_approval',
  carrierCanView: false,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'CUSTOMER_STORAGE_APPROVAL',
};

export const CUSTOMER_WAIT_TIME_NOTIFICATION = {
  name: 'Customer Wait Time Notification',
  value: 'customer_wait_time_notification',
  carrierCanView: false,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'CUSTOMER_WAIT_TIME_NOTIFICATION',
};

export const DELIVERY_ORDER = {
  name: 'Delivery Order',
  value: 'delivery_order',
  carrierCanView: true,
  carrierCanUpload: false,
  shipperCanView: false,
  shipperCanUpload: true,
  localizationSlug: 'DELIVERY_ORDER',
};

export const DELIVERY_ORDER_DRIVER = {
  name: 'Delivery Order Driver',
  value: 'delivery_order_driver',
  carrierCanView: true,
  carrierCanUpload: false,
  shipperCanView: false,
  shipperCanUpload: false,
  localizationSlug: 'DELIVERY_ORDER_DRIVER',
};

export const DEMURRAGE_CARGOMATIC_APPROVAL = {
  name: 'Demurrage Cargomatic Approval',
  value: 'demurrage_cargomatic_approval',
  localizationSlug: 'DEMURRAGE_CARGOMATIC_APPROVAL',
  carrierCanView: true,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: true,
};

export const DEMURRAGE_RECEIPT = {
  name: 'Demurrage Receipt',
  value: 'demurrage_receipt',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'DEMURRAGE_RECEIPT',
};

export const DETENTION_BACKUP = {
  name: 'Detention Backup',
  value: 'detention_backup',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'DETENTION_BACKUP',
};

export const DOCK_PAPERWORK_RECEIPT = {
  name: 'Dock Paperwork Receipt',
  value: 'dock_paperwork_receipt',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'DOCK_PAPERWORK_RECEIPT',
};

export const DRY_RUN = {
  name: 'Dry Run',
  value: 'dry_run',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'DRY_RUN',
};

export const DRY_RUN_CARGOMATIC_APPROVAL = {
  name: 'Dry Run Cargomatic Approval',
  value: 'dry_run_cargomatic_approval',
  localizationSlug: 'DRY_RUN_CARGOMATIC_APPROVAL',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
};

export const EIR_TICKET = {
  name: 'Eir Ticket',
  value: 'eir_ticket',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'EIR_TICKET',
};

export const EMAIL = {
  name: 'Email',
  value: 'email',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: false,
  shipperCanUpload: false,
  localizationSlug: 'EMAIL',
};

export const FLIP_RECEIPT = {
  name: 'Flip Receipt',
  value: 'flip_receipt',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'FLIP_RECEIPT',
};

export const FORM_ATME = {
  name: 'Form ATME',
  value: 'form_atme',
  carrierCanView: true,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'FORM_ATME',
};

export const GATE_FEE_RECEIPT = {
  name: 'Gate Fee Receipt',
  value: 'gate_fee_receipt',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'GATE_FEE_RECEIPT',
};

export const HAZMAT_DOCUMENTS = {
  name: 'Hazmat Documents',
  value: 'hazmat_documents',
  carrierCanView: true,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'HAZMAT_DOCUMENTS',
};

export const HAZARDOUS_NOTIFICATION_EMAIL = {
  name: 'Hazardous Notification Email',
  value: 'hazardous_notification_email',
  localizationSlug: 'HAZARDOUS_NOTIFICATION_EMAIL',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
};

export const INSPECTION_FORM = {
  name: 'Inspection Form',
  value: 'inspection_form',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'INSPECTION_FORM',
};

export const INTERCHANGE_IN = {
  name: 'Interchange In',
  value: 'interchange_in',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'INTERCHANGE_IN',
};

export const INTERCHANGE_OUT = {
  name: 'Interchange Out',
  value: 'interchange_out',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'INTERCHANGE_OUT',
};

export const INVOICE = {
  name: 'Invoice',
  value: 'shipment_invoice',
  carrierCanView: false,
  carrierCanUpload: false,
  shipperCanView: true,
  shipperCanUpload: false,
  requiredPreference: true,
  localizationSlug: 'INVOICE',
  count: 1,
};

export const LUMPER_FEE = {
  name: 'Lumper Fee',
  value: 'lumper_fee',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'LUMPER_FEE',
};

export const MAINTENANCE = {
  name: 'Maintenance',
  value: 'maintenance',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'MAINTENANCE',
};

export const MANIFEST_ECL = {
  name: 'Manifest ECL',
  value: 'manifest_ecl',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'MANIFEST_ECL',
};

export const MANIFEST_FCL = {
  name: 'Manifest FCL',
  value: 'manifest_fcl',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'MANIFEST_FCL',
};

export const MISC_DOCUMENT = {
  name: 'Misc Document',
  value: 'misc_document',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'MISC_DOCUMENT',
};

export const OTHER = {
  name: 'Backup',
  value: 'other',
  localizationSlug: 'BACKUP',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
};

export const OVERWEIGHT_NOTIFICATION = {
  name: 'Overweight Notification',
  value: 'overweight_notification',
  localizationSlug: 'OVERWEIGHT_NOTIFICATION',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
};

export const OVERWEIGHT_BACKUP = {
  name: 'Overweight Backup',
  value: 'other',
  localizationSlug: 'OVERWEIGHT_BACKUP',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
};

export const PACKING_LIST = {
  name: 'Packing List',
  value: 'packing_list',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'PACKING_LIST',
};

export const PAYOUT = {
  name: 'Payout',
  value: 'payout',
  carrierCanView: true,
  carrierCanUpload: false,
  shipperCanView: false,
  shipperCanUpload: false,
  localizationSlug: 'PAYOUT',
};

export const PER_DIEM_RECEIPT = {
  name: 'Per Diem Receipt',
  value: 'per_diem_receipt',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'PER_DIEM_RECEIPT',
};

export const PIER_PASS_RECEIPT = {
  name: 'Pier Pass Receipt',
  value: 'pier_pass_receipt',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'PIER_PASS_RECEIPT',
};

export const PORT_FEE_RECEIPT = {
  name: 'Port Fee Receipt',
  value: 'port_fee_receipt',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'PORT_FEE_RECEIPT',
};

export const PREPAID_RECEIPT = {
  name: 'Prepaid Receipt',
  value: 'prepaid_receipt',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'PREPAID_RECEIPT',
};

export const PRE_PULL_CARGOMATIC_APPROVAL = {
  name: 'Pre-Pull Cargomatic Approval',
  value: 'pre_pull_cargomatic_approval',
  localizationSlug: 'PRE_PULL_CARGOMATIC_APPROVAL',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
};

export const PROFILE_PICTURE = {
  name: 'Profile Picture',
  value: 'profile_picture',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: true,
};

export const PROOF_OF_COMPLETION = {
  name: 'Proof of Completion',
  value: 'proof_of_completion',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'PROOF_OF_COMPLETION',
};

export const PROOF_OF_DELIVERY = {
  name: 'Proof of Delivery',
  value: 'proof_of_delivery',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'PROOF_OF_DELIVERY',
};

export const PROOF_OF_PICKUP = {
  name: 'Proof of Pickup',
  value: 'proof_of_pickup',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'PROOF_OF_PICKUP',
};

export const RATE_CONFIRMATION = {
  name: 'Rate Confirmation',
  value: 'rate_confirmation',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: false,
  shipperCanUpload: false,
  localizationSlug: 'RATE_CONFIRMATION',
};

export const REPAIR_INVOICE = {
  name: 'Repair Invoice',
  value: 'repair_invoice',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: true,
  localizationSlug: 'REPAIR_INVOICE',
};

export const SCALE_NOTIFICATION = {
  name: 'Scale Notification',
  value: 'scale_notification',
  localizationSlug: 'SCALE_NOTIFICATION',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
};

export const SCALE_TICKET = {
  name: 'Scale Ticket',
  value: 'scale_ticket',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'SCALE_TICKET',
};

export const STOP_OFF_CARGOMATIC_APPROVAL = {
  name: 'Stop Off Cargomatic Approval',
  value: 'stop_off_cargomatic_approval',
  localizationSlug: 'STOP_OFF_CARGOMATIC_APPROVAL',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
};

export const STORAGE_CARGOMATIC_APPROVAL = {
  name: 'Storage Cargomatic Approval',
  value: 'storage_cargomatic_approval',
  localizationSlug: 'STORAGE_CARGOMATIC_APPROVAL',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
};

export const STORAGE_RECEIPT = {
  name: 'Storage Receipt',
  value: 'storage_receipt',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'STORAGE_RECEIPT',
};

export const TROUBLE_TICKETS = {
  name: 'Trouble Tickets',
  value: 'trouble_tickets',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
  localizationSlug: 'TROUBLE_TICKETS',
};

export const WAIT_TIME_CONSIGNEE_NOTIFICATION = {
  name: 'Wait Time Consignee Notification',
  value: 'wait_time_consignee_notification',
  localizationSlug: 'WAIT_TIME_CONSIGNEE_NOTIFICATION',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
};

export const WAIT_TIME_INTERCHANGE_IN = {
  name: 'Wait Time Interchange In',
  value: 'wait_time_interchange_in',
  localizationSlug: 'WAIT_TIME_INTERCHANGE_IN',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
};

export const WAIT_TIME_INTERCHANGE_OUT = {
  name: 'Wait Time Interchange Out',
  value: 'wait_time_interchange_out',
  localizationSlug: 'WAIT_TIME_INTERCHANGE_OUT',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
};

export const WAIT_TIME_SHIPPER_NOTIFICATION = {
  name: 'Wait Time Shipper Notification',
  value: 'wait_time_shipper_notification',
  localizationSlug: 'WAIT_TIME_SHIPPER_NOTIFICATION',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
};

export const WAIT_TIME_TERMINAL_NOTIFICATION = {
  name: 'Wait Time Terminal Notification',
  value: 'wait_time_terminal_notification',
  localizationSlug: 'WAIT_TIME_TERMINAL_NOTIFICATION',
  carrierCanView: true,
  carrierCanUpload: true,
  shipperCanView: true,
  shipperCanUpload: false,
};

const DocumentTypes = [
  ACCESSORIAL_DOCUMENT,
  BARCODE,
  BARE_CHASSIS_INTERCHANGE,
  BILL_OF_LADING,
  BOBTAIL_CARGOMATIC_APPROVAL,
  CARRIER_INVOICE,
  CHASSIS_INTERCHANGE_IN,
  CHASSIS_INTERCHANGE_OUT,
  CHASSIS_INVOICE,
  CHASSIS_PHOTO,
  CLASSIC_POD,
  CREDIT_MEMO,
  CROSSDOCK_TALLY_SHEET,
  CTF_RECEIPT,
  CUSTOM,
  CUSTOMER_APPROVAL,
  CUSTOMER_BILL_OF_LADING,
  CUSTOMER_BOBTAIL_APPROVAL,
  CUSTOMER_CHASSIS_SPLIT_APPROVAL,
  CUSTOMER_DELIVERY_ORDER,
  CUSTOMER_DEMURRAGE_APPROVAL,
  CUSTOMER_DRY_RUN_APPROVAL,
  CUSTOMER_PER_DIEM_APPROVAL,
  CUSTOMER_PREPULL_APPROVAL,
  CUSTOMER_STOP_OFF_APPROVAL,
  CUSTOMER_STORAGE_APPROVAL,
  CUSTOMER_WAIT_TIME_NOTIFICATION,
  DELIVERY_ORDER,
  DEMURRAGE_CARGOMATIC_APPROVAL,
  DEMURRAGE_RECEIPT,
  DETENTION_BACKUP,
  DOCK_PAPERWORK_RECEIPT,
  DRY_RUN,
  DRY_RUN_CARGOMATIC_APPROVAL,
  EIR_TICKET,
  EMAIL,
  FLIP_RECEIPT,
  FORM_ATME,
  GATE_FEE_RECEIPT,
  HAZMAT_DOCUMENTS,
  HAZARDOUS_NOTIFICATION_EMAIL,
  INSPECTION_FORM,
  INTERCHANGE_IN,
  INTERCHANGE_OUT,
  INVOICE,
  LUMPER_FEE,
  MAINTENANCE,
  MANIFEST_ECL,
  MANIFEST_FCL,
  MISC_DOCUMENT,
  OTHER,
  OVERWEIGHT_BACKUP,
  OVERWEIGHT_NOTIFICATION,
  PACKING_LIST,
  PAYOUT,
  PER_DIEM_RECEIPT,
  PIER_PASS_RECEIPT,
  PORT_FEE_RECEIPT,
  PREPAID_RECEIPT,
  PRE_PULL_CARGOMATIC_APPROVAL,
  PROFILE_PICTURE,
  PROOF_OF_COMPLETION,
  PROOF_OF_DELIVERY,
  PROOF_OF_PICKUP,
  RATE_CONFIRMATION,
  REPAIR_INVOICE,
  SCALE_NOTIFICATION,
  SCALE_TICKET,
  STOP_OFF_CARGOMATIC_APPROVAL,
  STORAGE_CARGOMATIC_APPROVAL,
  STORAGE_RECEIPT,
  TROUBLE_TICKETS,
  WAIT_TIME_CONSIGNEE_NOTIFICATION,
  WAIT_TIME_INTERCHANGE_IN,
  WAIT_TIME_INTERCHANGE_OUT,
  WAIT_TIME_SHIPPER_NOTIFICATION,
  WAIT_TIME_TERMINAL_NOTIFICATION,
];

export const documentTypeNameMap = DocumentTypes.reduce(
  (map, { name, value }) => ({
    ...map,
    [value]: name,
  }),
  {},
);

// please keep sorted to avoid puplicates
export const invoiceDocumentPreferenceDocTypes = [
  BARE_CHASSIS_INTERCHANGE,
  BILL_OF_LADING,
  CARRIER_INVOICE,
  CHASSIS_INTERCHANGE_IN,
  CHASSIS_INTERCHANGE_OUT,
  CHASSIS_INVOICE,
  CHASSIS_PHOTO,
  CROSSDOCK_TALLY_SHEET,
  CTF_RECEIPT,
  CUSTOMER_APPROVAL,
  CUSTOMER_BILL_OF_LADING,
  CUSTOMER_BOBTAIL_APPROVAL,
  CUSTOMER_CHASSIS_SPLIT_APPROVAL,
  CUSTOMER_DELIVERY_ORDER,
  CUSTOMER_DEMURRAGE_APPROVAL,
  CUSTOMER_DRY_RUN_APPROVAL,
  CUSTOMER_PER_DIEM_APPROVAL,
  CUSTOMER_PREPULL_APPROVAL,
  CUSTOMER_STOP_OFF_APPROVAL,
  CUSTOMER_STORAGE_APPROVAL,
  CUSTOMER_WAIT_TIME_NOTIFICATION,
  DEMURRAGE_RECEIPT,
  DETENTION_BACKUP,
  DOCK_PAPERWORK_RECEIPT,
  DRY_RUN,
  EIR_TICKET,
  FLIP_RECEIPT,
  FORM_ATME,
  GATE_FEE_RECEIPT,
  HAZMAT_DOCUMENTS,
  INSPECTION_FORM,
  INTERCHANGE_IN,
  INTERCHANGE_OUT,
  INVOICE,
  LUMPER_FEE,
  MAINTENANCE,
  MANIFEST_ECL,
  MANIFEST_FCL,
  PACKING_LIST,
  PER_DIEM_RECEIPT,
  PIER_PASS_RECEIPT,
  PORT_FEE_RECEIPT,
  PREPAID_RECEIPT,
  PROOF_OF_COMPLETION,
  PROOF_OF_DELIVERY,
  PROOF_OF_PICKUP,
  REPAIR_INVOICE,
  SCALE_TICKET,
  STORAGE_RECEIPT,
  TROUBLE_TICKETS,
];

export const invoiceDocumentPreferenceDocTypesMap =
  invoiceDocumentPreferenceDocTypes.reduce(
    (map, pref) => ({
      ...map,
      [pref.value]: pref,
    }),
    {},
  );

export const shipmentDocTypes = [
  BARCODE,
  BARE_CHASSIS_INTERCHANGE,
  BILL_OF_LADING,
  CARRIER_INVOICE,
  CHASSIS_INVOICE,
  CHASSIS_PHOTO,
  CROSSDOCK_TALLY_SHEET,
  CTF_RECEIPT,
  CUSTOMER_APPROVAL,
  CUSTOMER_DELIVERY_ORDER,
  CUSTOMER_DEMURRAGE_APPROVAL,
  CUSTOMER_DRY_RUN_APPROVAL,
  CUSTOMER_PER_DIEM_APPROVAL,
  CUSTOMER_PREPULL_APPROVAL,
  CUSTOMER_STOP_OFF_APPROVAL,
  CUSTOMER_STORAGE_APPROVAL,
  CUSTOMER_CHASSIS_SPLIT_APPROVAL,
  CUSTOMER_BOBTAIL_APPROVAL,
  CUSTOMER_WAIT_TIME_NOTIFICATION,
  DELIVERY_ORDER,
  DEMURRAGE_RECEIPT,
  DETENTION_BACKUP,
  DOCK_PAPERWORK_RECEIPT,
  DRY_RUN,
  EMAIL,
  FLIP_RECEIPT,
  FORM_ATME,
  GATE_FEE_RECEIPT,
  HAZMAT_DOCUMENTS,
  INSPECTION_FORM,
  INTERCHANGE_IN,
  INTERCHANGE_OUT,
  LUMPER_FEE,
  MAINTENANCE,
  MANIFEST_ECL,
  MANIFEST_FCL,
  PACKING_LIST,
  PER_DIEM_RECEIPT,
  PIER_PASS_RECEIPT,
  PORT_FEE_RECEIPT,
  PREPAID_RECEIPT,
  PROOF_OF_COMPLETION,
  PROOF_OF_DELIVERY,
  PROOF_OF_PICKUP,
  REPAIR_INVOICE,
  SCALE_TICKET,
  STORAGE_RECEIPT,
  TROUBLE_TICKETS,
  CUSTOM,
];

export const shipmentDocTypesMap = shipmentDocTypes.reduce(
  (map, docType) => ({
    ...map,
    [docType.value]: docType,
  }),
  {},
);

export const shipperViewableDocTypes = shipmentDocTypes
  .filter((docType) => docType.shipperCanView)
  .concat(INVOICE);

export const shipperViewableDocTypesMap = shipperViewableDocTypes.reduce(
  (map, docType) => ({
    ...map,
    [docType.value]: docType,
  }),
  {},
);

export const shipperDocTypes = shipmentDocTypes.filter(
  (docType) => docType.shipperCanUpload,
);
export const shipperDocTypesMap = shipperDocTypes.reduce(
  (map, docType) => ({
    ...map,
    [docType.value]: docType,
  }),
  {},
);

export const carrierViewableDocTypes = shipmentDocTypes.filter(
  (docType) => docType.carrierCanView,
);

export const carrierViewableDocTypesMap = carrierViewableDocTypes.reduce(
  (map, docType) => ({
    ...map,
    [docType.value]: docType,
  }),
  {},
);

export const carrierDocTypes = shipmentDocTypes.filter(
  (docType) => docType.carrierCanUpload,
);

export const carrierDocTypesMap = carrierDocTypes.reduce(
  (map, docType) => ({
    ...map,
    [docType.value]: docType,
  }),
  {},
);

export const orderDocTypes = [
  BILL_OF_LADING,
  CROSSDOCK_TALLY_SHEET,
  DELIVERY_ORDER,
  DOCK_PAPERWORK_RECEIPT,
  EMAIL,
  FORM_ATME,
  HAZMAT_DOCUMENTS,
  MANIFEST_ECL,
  MANIFEST_FCL,
  PACKING_LIST,
  CUSTOM,
];

export const orderDocTypesMap = orderDocTypes.reduce(
  (map, docType) => ({
    ...map,
    [docType.value]: docType,
  }),
  {},
);

export const shipperPortalDocTypes = [
  BILL_OF_LADING,
  CUSTOMER_APPROVAL,
  CUSTOMER_DELIVERY_ORDER,
  CUSTOMER_DEMURRAGE_APPROVAL,
  CUSTOMER_DRY_RUN_APPROVAL,
  CUSTOMER_PER_DIEM_APPROVAL,
  CUSTOMER_PREPULL_APPROVAL,
  CUSTOMER_STOP_OFF_APPROVAL,
  CUSTOMER_STORAGE_APPROVAL,
  CUSTOMER_CHASSIS_SPLIT_APPROVAL,
  CUSTOMER_BOBTAIL_APPROVAL,
  CUSTOMER_WAIT_TIME_NOTIFICATION,
  FORM_ATME,
  HAZMAT_DOCUMENTS,
  MANIFEST_ECL,
  MANIFEST_FCL,
  PACKING_LIST,
  CUSTOM,
];

export const shipperPortalDocTypesMap = shipperPortalDocTypes.reduce(
  (map, doc) => ({
    ...map,
    [doc.value]: doc,
  }),
);

export const carrierPortalDocTypes = [
  BARE_CHASSIS_INTERCHANGE,
  CARRIER_INVOICE,
  CHASSIS_INVOICE,
  CHASSIS_PHOTO,
  CROSSDOCK_TALLY_SHEET,
  CUSTOM,
  CTF_RECEIPT,
  DELIVERY_ORDER,
  DEMURRAGE_RECEIPT,
  DETENTION_BACKUP,
  DOCK_PAPERWORK_RECEIPT,
  DRY_RUN,
  EMAIL,
  FLIP_RECEIPT,
  GATE_FEE_RECEIPT,
  INSPECTION_FORM,
  INTERCHANGE_IN,
  INTERCHANGE_OUT,
  LUMPER_FEE,
  MAINTENANCE,
  MANIFEST_ECL,
  MANIFEST_FCL,
  PACKING_LIST,
  PER_DIEM_RECEIPT,
  PIER_PASS_RECEIPT,
  PORT_FEE_RECEIPT,
  PREPAID_RECEIPT,
  PROOF_OF_COMPLETION,
  PROOF_OF_DELIVERY,
  PROOF_OF_PICKUP,
  REPAIR_INVOICE,
  SCALE_TICKET,
  STORAGE_RECEIPT,
  TROUBLE_TICKETS,
];

export const carrierPortalDocTypesMap = carrierPortalDocTypes.reduce(
  (map, doc) => ({
    ...map,
    [doc.value]: doc,
  }),
);

export const hiddenFromCarrier = [
  CUSTOMER_APPROVAL,
  CUSTOMER_BOBTAIL_APPROVAL,
  CUSTOMER_CHASSIS_SPLIT_APPROVAL,
  CUSTOMER_DEMURRAGE_APPROVAL,
  CUSTOMER_DRY_RUN_APPROVAL,
  CUSTOMER_PER_DIEM_APPROVAL,
  CUSTOMER_PREPULL_APPROVAL,
  CUSTOMER_STOP_OFF_APPROVAL,
  CUSTOMER_STORAGE_APPROVAL,
  CUSTOMER_WAIT_TIME_NOTIFICATION,
];

export const hiddenFromCarrierMap = hiddenFromCarrier.reduce(
  (map, doc) => ({
    ...map,
    [doc.value]: doc,
  }),
  {},
);

export const carrierAccessorialDocumentsMap = {
  bobtail: [BOBTAIL_CARGOMATIC_APPROVAL],
  chassis: [INTERCHANGE_IN, INTERCHANGE_OUT],
  chassis_split: [BARE_CHASSIS_INTERCHANGE],
  clean_truck_fee: [CTF_RECEIPT],
  demurrage: [DEMURRAGE_RECEIPT, DEMURRAGE_CARGOMATIC_APPROVAL],
  dry_run: [DRY_RUN_CARGOMATIC_APPROVAL],
  flip_charge: [FLIP_RECEIPT],
  hazmat: [HAZARDOUS_NOTIFICATION_EMAIL],
  overweight: [OVERWEIGHT_NOTIFICATION, OVERWEIGHT_BACKUP],
  per_diem: [PER_DIEM_RECEIPT],
  pier_pass: [PIER_PASS_RECEIPT],
  pre_pull: [PRE_PULL_CARGOMATIC_APPROVAL],
  scale_ticket: [SCALE_TICKET, SCALE_NOTIFICATION],
  stop_off: [STOP_OFF_CARGOMATIC_APPROVAL],
  storage: [STORAGE_CARGOMATIC_APPROVAL],
  tri_axle: [INTERCHANGE_IN, INTERCHANGE_OUT],
  wait_time_at_consignee: [WAIT_TIME_CONSIGNEE_NOTIFICATION, PROOF_OF_DELIVERY],
  wait_time_at_shipper: [WAIT_TIME_SHIPPER_NOTIFICATION, PROOF_OF_DELIVERY],
  wait_time_at_terminal: [
    WAIT_TIME_TERMINAL_NOTIFICATION,
    WAIT_TIME_INTERCHANGE_OUT,
    WAIT_TIME_INTERCHANGE_IN,
  ],
  other: [OTHER],
};

export const accessorialWithBackupDocumentsExcluded = ['fuel_surcharge'];

export const accessorialRequestDocsWhitelist = {
  [INTERCHANGE_IN.value]: true,
  [INTERCHANGE_OUT.value]: true,
  [CUSTOMER_APPROVAL.value]: true,
  [CUSTOMER_DELIVERY_ORDER.value]: true,
  [CUSTOMER_DEMURRAGE_APPROVAL.value]: true,
  [CUSTOMER_DRY_RUN_APPROVAL.value]: true,
  [CUSTOMER_PER_DIEM_APPROVAL.value]: true,
  [CUSTOMER_PREPULL_APPROVAL.value]: true,
  [CUSTOMER_STOP_OFF_APPROVAL.value]: true,
  [CUSTOMER_STORAGE_APPROVAL.value]: true,
  [CUSTOMER_CHASSIS_SPLIT_APPROVAL.value]: true,
  [CUSTOMER_BOBTAIL_APPROVAL.value]: true,
  [CUSTOMER_WAIT_TIME_NOTIFICATION.value]: true,
};
